import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddProjectsService } from '../../../pages/admin/add-projects.service';
import { FormsModule } from '@angular/forms';
import { SpinnerdetialComponent } from 'src/app/helpers/loading/spinnerdetial/spinnerdetial.component';
import { NavbarComponent } from '../../navbar/navbar.component';

import { EditorModule } from "@tinymce/tinymce-angular";
import { Router } from '@angular/router';
declare var tinymce: any;

@Component({
  selector: 'app-project-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, SpinnerdetialComponent, NavbarComponent],
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {
  dataDetail: any;
  idDetail: any;
  isLoading = false;

  constructor(private addProjectService: AddProjectsService, private router: Router) { }

  ngOnInit() {
    this.idDetail = history.state.value
    console.log(this.idDetail)
    this.doGetById();
  }
  doGetById(){
    this.isLoading = true;
    this.addProjectService.getById(this.idDetail).subscribe((value: any) => {
      console.log(value);
      console.log(value.message, 'ini message')
      if(value.message == "Auth failed" || value.Status == 401){
        this.router.navigate(['404']);
      }
      this.dataDetail = value.data
      this.isLoading = false
    }, error => {
      if(error.code == 401 || error.message == 'Auth failed'){
        this.router.navigate(['404']);
      }
    })
  }

  doGetByIds(){
    this.isLoading = true;
   const data = this.addProjectService.fetchDetail(this.idDetail)
   console.log(data)
  }


}
